import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon'; // 
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MaterialModule } from './@Shared/modules/material.module';
import {FlexLayoutModule } from '@angular/flex-layout';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthWebsiteInterceptor } from './@Modules/@website/@auth/auth-material/auth-website.interceptor';
import { AgGridModule } from 'ag-grid-angular';
import { NgxOrgChartModule } from '@fdjlss/ngx-org-chart';
import { SurveyAttemptByUserComponent } from './@Free-pages/survey-attempt-by-user/survey-attempt-by-user.component';
import { SurveyModule } from 'survey-angular-ui';
import {  MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogIssueComponent } from './shared/confirm-dialog-issue/confirm-dialog-issue.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [
    AppComponent,
    SurveyAttemptByUserComponent,
    ConfirmDialogComponent,
    ConfirmDialogIssueComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatTooltipModule,
    HttpClientModule,
    FlexLayoutModule,
    MatIconModule, 
    MatButtonModule,
    MatDialogModule,
    AgGridModule,
    MatProgressSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgxOrgChartModule,
    SurveyModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass:AuthWebsiteInterceptor ,  multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
